import type { PartnerTheme } from '../types';

export function BrandMark({ compact = false, theme }: { compact?: boolean; theme?: PartnerTheme | null }) {
  if (compact) {
    return <div className="brand-mark brand-mark--compact" aria-label="Innova TV">
      <img className="brand-mark__compact-wordmark" src="/innovatv-wordmark.png" alt="" />
    </div>;
  }
  if (theme?.logo_url && theme.slug !== 'innova') {
    return <div className="brand-mark brand-mark--partner" aria-label={`${theme.name} com Innova TV`}>
      <img src={theme.logo_url} alt={theme.short_name || theme.name} />
      <small>com InnovaTV</small>
    </div>;
  }
  return (
    <div className="brand-mark" aria-label="Innova TV">
      <img className="brand-mark__official" src="/innovatv-wordmark.png" alt="INNOVA TV" />
    </div>
  );
}
